import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  CloseButton,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Text,
  InputGroup,
  InputRightElement,
  Checkbox,
  useStyleConfig
} from "@chakra-ui/react";
import {ViewIcon, ViewOffIcon} from '@chakra-ui/icons';
import {Link as ReactRouterLink, useNavigate} from 'react-router-dom'
import React, {useEffect, useState} from "react";
import {Auth} from "../../lib/Auth";
import LogoComponent from '../Logo/LogoComponent';
import FormPasswordComponent from "../Password/FormPasswordComponent";

export default function LoginComponent({
                                         setIsLoading, isAlertVisible, alertMessage, alertStatus, showAlert, hideAlert
                                       }) {

  const modalBoxStyles = useStyleConfig('ModalBox', { variant: 'solid' });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [trustDevice, setTrustDevice] = useState(false);

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const processUseAuth = (response, showmsg) => {
    if (response.type === "ok") {
      if (response.data?.business) {
        localStorage.setItem('business', JSON.stringify(response.data.business))
      }
      return response.data.user;
    } else {
      if (showmsg) {
        showAlert(response.msg || "Login failed");
      }

      return null;
    }
  };
  const navigate = useNavigate();
  const getCurrentAuthenticatedUser = async () => {
    try {
      return Auth.currentAuthenticatedUser();
    } catch (error) {
      showAlert(`Error during sign in: ${error.message}`);
    }
  };

  const customSignIn = async (event) => {
    event.preventDefault();
    if (!isEmailValid(username)) {
      showAlert("Please enter a valid email address.");
      return;
    }
    hideAlert();
    try {
      const prevRememberMeToken = localStorage.getItem('rememberMeToken');
      const loginData = {
        username, password, trustDevice: trustDevice
      };
      if (prevRememberMeToken) {
        loginData.rememberMeToken = prevRememberMeToken;
      }
      const response = await Auth.signIn(loginData);
      if (response.type === "2fa_required") {
        navigate("/two-factor-auth", {
          state: {
            uid: response.data?.uid,
            email: username,
            password: password,
            trustDevice: trustDevice
          }
        });
        return;
      }
      if (response.type === "error") {
        showAlert(response.msg);
        return;
      }
      const loggedInUser = processUseAuth(response, true);
      Auth.storeUser(loggedInUser);
    } catch (error) {
      showAlert(`Error during sign in: ${error.message}`);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    getCurrentAuthenticatedUser(Auth.user)
      .then(processUseAuth)
      .then((u) => {
        if ((Auth.user && !u) || (!Auth.user && u)) {
          Auth.storeUser(u);
        }
        setIsLoading(false);
        if (u) {
          Auth.login(u);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, [Auth.user]);

  return (<Flex minH="100vh" justifyContent="center" alignItems="center">
    <Box
      p={8}
      minWidth={{base: "90%", sm: "400px", md: "500px", lg: "500px"}}
      maxWidth={{base: "90%", sm: "540px", md: "600px", lg: "800px"}}
      borderWidth={1}
      borderRadius={8}
      boxShadow="lg"
      __css={modalBoxStyles}
    >
      {isAlertVisible && (<Alert status={alertStatus}>
        <AlertIcon/>
        <Box flex="1">
          <AlertTitle>
            <Text casing="capitalize">{alertStatus}</Text>
          </AlertTitle>
          <AlertDescription display="block">
            {alertMessage}
          </AlertDescription>
        </Box>
        <CloseButton
          position="absolute"
          right="8px"
          top="8px"
          onClick={() => hideAlert()}
        />
      </Alert>)}
      <LogoComponent isCollapsed={false} boxSize="5rem" mx="auto" mb={4} ></LogoComponent>
      <Box textAlign="center">
        <Heading
          as="h1"
          fontSize={{base: "16px", md: "20px", lg: "24px"}}
          fontWeight="600"
          lineHeight="140%"
        >
          Sign In
        </Heading>
      </Box>
      <Box my={4} textAlign="left">
        <form onSubmit={customSignIn}>
          <FormControl isRequired>
            <FormLabel
              htmlFor="username"
            >
              Email or Username
            </FormLabel>
            <Input
              type="text"
              id="username"
              onChange={(e) => setUsername(e.target.value)}
            />
          </FormControl>
          <Box mt={4}>
            <FormPasswordComponent
              id="password"
              label="Password"
              isRequired
              onChange={setPassword}>
            </FormPasswordComponent>
          </Box>
          <Box mt={2}>
            <Checkbox
              isChecked={trustDevice}
              onChange={(e) => setTrustDevice(e.target.checked)}
            >
              Trust this device for 30 days
            </Checkbox>
          </Box>
          <Box my={1} mt={2} textAlign="right">
            <Link as={ReactRouterLink} onClick={() => hideAlert()} to="/forgot_password">
              Forgot password?
            </Link>
          </Box>
          <Button width="full" mt={4} type="submit">
            Sign In
          </Button>
        </form>
      </Box>
    </Box>
  </Flex>);
}
